const consts = {
  INVESTMENT_STYLE: ['Value-Add', 'Yield-Focused'],
  INPUT_TYPES_MAP: {
    string: 'text',
    currency: 'text',
    integer: 'number',
    float: 'number',
    choiceconst: 'text',
  },
  INPUT_COMPONENT_MAP: {
    state: 'BaseFormSelectState',
    country: 'BaseFormSelect',
    string: 'BaseFormInput',
    text: 'BaseFormInput',
    email: 'BaseFormInput',
    tel: 'BaseFormInputPhone',
    phone: 'BaseFormInputPhone',
    password: 'BaseFormInput',
    number: 'BaseFormInput',
    integer: 'BaseFormInput',
    currency: 'BaseFormInputCurrency',
    float: 'BaseFormInput',
    choose: 'BaseFormSelect',
    choice: 'BaseFormSelect',
    select: 'BaseFormSelect',
    datetime: 'BaseFormDate',
    date: 'BaseFormDate',
    radio: 'BaseFormRadio',
    booleanradio: 'BaseFormRadio',
    range: 'BaseFormRange',
    file: 'BaseFormFileSingle',
    filemulti: 'BaseFormFileMulti',
    'file-multi': 'BaseFormFileMulti',
    choiceconst: 'BaseFormSelect',
    boolean: 'BaseFormCheckbox',
    bool: 'BaseFormCheckbox',
    checkbox: 'BaseFormCheckbox',
    checkboxgroup: 'BaseFormCheckboxGroup',
    website: 'BaseFormWebsite',
    textarea: 'BaseFormTextarea',
    address: 'BaseFormInputAddress',
    switch: 'BaseFormSwitch',
    city: 'BaseFormInputCity',
  },
  WHITEPAPER_URL: 'https://info.acretrader.com/hubfs/AcreTrader%20Files/2023%20Report%20Investing%20in%20U.S.%20Farmland.pdf',
  ADDITIONAL_DOCUMENTS_URL: 'https://info.acretrader.com/hubfs/Useful%20Documents%20For%20Selling%20Your%20Farmland.pdf',
  CONTACTS: {
    phone: '(888) 958-1470',
    alternativePhone: '(479) 335-5660',
    email: 'info@acretrader.com',
    twitter: 'https://twitter.com/acretraderinc',
    facebook: 'https://www.facebook.com/acretraderinc',
    angel: 'https://angel.co/acretrader',
    instagram: 'https://www.instagram.com/acretrader',
    mapLink: 'https://goo.gl/maps/7LXffBa1nMNMooCN8',
    linkedin: 'https://www.linkedin.com/company/acre-trader',
    bbbLink: 'https://www.bbb.org/us/ar/fayetteville/profile/real-estate-investing/acretrader-inc-0935-90372130',
    streetAddress: '26 W. Center St., Suite 202',
    addressLocality: 'Fayetteville',
    addressRegion: 'AR',
    postalCode: '72701',
    youtube: 'https://www.youtube.com/@AcreTrader',
  },
  PROFILE_TABS: [
    {
      value: 'investments',
      text: 'Portfolio',
      icon: 'fa-hand-holding-usd',
      tabs: ['overview', 'funding', 'active', 'exited', 'wire'],
    },
    {
      value: 'accounts',
      text: 'Accounts',
      icon: 'fa-user-alt',
    },
    {
      value: 'wallet',
      text: 'Wallet',
      icon: 'fa-wallet',
    },
    {
      value: 'notifications',
      text: 'Notifications',
      icon: 'fa-bell',
      tabs: ['system', 'updates'],
    },
    {
      value: 'settings',
      text: 'Settings',
      icon: 'fa-cog',
      tabs: ['login-credentials', 'security'],
    },
  ],
  BANK_LINKED_SUCCESS_MESSAGE: 'Congratulations, you have added a new funding source to your AcreTrader wallet.',
  BANK_LINKED_SUCCESS_ALT_MESSAGE: `Congratulations, you have added a new funding source to your
    <a href="/profile/accounts">AcreTrader wallet.</a>`,
  BANK_LINKED_SUCCESS_MANUAL_SUB_MESSAGE: `Please verify the two small deposits that will made to
    your bank account within the next 1-2 business days. If you would like to make an investment
    sooner, you can always choose another funding option such as ACH or Wire during the investment process.`,
  BANK_LINKED_SUCCESS_AUTO_SUB_MESSAGE: `Deposit verification will be complete within the next 1-2
    business days. If you would like to make an investment sooner, you can always choose another
    funding option such as ACH or Wire during the investment process.`,
  ACCREDITATION_SKIP_MESSAGE: [
    'It appears you are currently a non-accredited investor.',
    `If you become accredited, or selected this option in error,
    please <a id="link-open-accreditation" class="link-1" href="#">update</a> your profile.
    You can find the definitions of accredited investor
    <a class="link-1" target="_blank" rel="noreferrer" href="https://www.investor.gov/additional-resources/news-alerts/alerts-bulletins/updated-investor-bulletin-accredited-investors">here</a>.
    Our offerings are currently only open to accredited investors under Regulation D of the Securities Act.
    However, stay tuned! We intend to provide offerings to non-accredited investors in the near future,
    and we will let you know when these are ready to launch.
    In the meantime, please feel free to get to know us better and learn more about farmland investing.`,
  ],
  ACCREDITATION_NON_APPLY_TO_ME_MESSAGE: [
    'It appears you may not be an accredited investor.',
    `If you are accredited, please <a id="link-open-accreditation" class="link-1" href="#">update</a>
     your profile. You can find the definitions of
    accredited investor
    <a class="link-1" target="_blank" rel="noreferrer" href="https://www.investor.gov/additional-resources/news-alerts/alerts-bulletins/updated-investor-bulletin-accredited-investors">here</a>.
    Our offerings are currently only open to accredited investors under Regulation D of the Securities Act.
    However, if you are not accredited, stay tuned! We intend to provide offerings to
    non-accredited investors in the near future, and we will let you know when these are ready to launch.
    In the meantime, please feel free to get to know us better and learn more about farmland investing.`,
  ],
  INVESTMENT_PROFILE_SDIRA_EXIST_MESSAGE: `You already have an SDIRA profile. We recommend using your existing
        profile unless you have created a new SDIRA account.`,
  FARM_LIST_SORT_OPTIONS: [
    {
      text: 'Most Funded',
      value: 'subscribed_shares:desc',
    },
    {
      text: 'Lowest Price',
      value: 'price:asc',
    },
    {
      text: 'Highest Price',
      value: 'price:desc',
    },
    {
      text: 'Lowest Yield',
      value: 'gross_yield:asc',
    },
    {
      text: 'Highest Yield',
      value: 'gross_yield:desc',
    },
  ],
  BLOG_LIST_SORT_OPTIONS: [
    {
      text: 'Most Commented',
      value: 'commented',
    },
    {
      text: 'Years',
      value: 'years',
    },
  ],
  INVESTMENT_STEPS: [
    {
      name: 'Amount',
      value: 'amount',
    },
    {
      name: 'Ownership',
      value: 'ownership',
    },
    {
      name: 'Signature',
      value: 'signatures',
    },
    {
      name: 'Funding',
      value: 'funding',
    },
    {
      name: 'Accreditation',
      value: 'accreditation',
    },
    {
      name: 'Confirmation',
      value: 'confirmation',
    },
  ],
  INVESTMENT_STEPS_CONST: {
    AMOUNT: 'amount',
    OWNERSHIP: 'ownership',
    SIGNATURES: 'signatures',
    FUNDING: 'funding',
    ACCREDITATION: 'accreditation',
    CONFIRMATION: 'confirmation',
  },
  INVESTMENT_LEAVE_MESSAGES: {
    PROCESS: 'Please note that your investment will not be reserved until you complete the process. Are you sure you want to leave?',
    STEP: 'Please note that you have unsaved changes on this step. Are you sure you want to leave?',
    CANCEL: 'Are you sure you want to cancel this investment?',
  },
  INVESTMENT_NOT_ENOUGH_SHARES_MESSAGES: [
    'We\'re sorry for the inconvenience, but unfortunately another investor just invested in this offering and there are no longer any {sharesOrUnits} available. Please check our other offerings <a class="link-2 small-link" href="/explore">here</a>.',
    'Unfortunately, another investor has just purchased {sharesOrUnits} in this offering and there are now only {shareNumber} {sharesOrUnits} available. Please return to the <a class="link-2 small-link" href="{amountHref}">Amount step</a> of the investment process and update the number of {sharesOrUnits}.',
    'Unfortunately, another investor has just purchased {sharesOrUnits} in this offering. Please return to the <a class="link-2 small-link" href="{amountHref}">Amount step</a> of the investment process and update the number of {sharesOrUnits}.',
  ],
  INVESTMENT_RESIGN_REQUIRED_MESSAGE: `Because changes were made to your information,
    we need to re-confirm the affirmations and documents provided below. Thanks.`,
  INVESTMENT_KYC: {
    OK: 'Verification was successful',
    FAILED: 'Verification is failed',
    IDENTIFY_ERROR: 'Can not verify your identity',
    IDENTIFY_ERROR_MESSAGE: `We were unable to verify your identity.
      Please restart the investment process to correct any potential errors. If you have additional issues,
      please feel free to <a class="link-1" href="/company/contact-us" target="_blank">contact us</a>`,
  },
  INVESTMENT_STEP_BY_STATUS: {
    0: 'ownership',
    1: 'ownership',
    3: 'ownership',
    4: 'signatures',
    7: 'funding',
    8: 'accreditation',
    9: 'funding',
    15: 'confirmation',
    19: 'confirmation',
  },
  INVESTMENT_KYC_ERROR_SERVER_MESSAGES: 'You cannot do this until your identity is confirmed.',
  INVESTMENT_KYC_ERROR_MESSAGES: {
    '': 'Please provide additional info for KYC requirements',
    unverified: 'ID verification form is sent. It may take some time to verify it.',
    suspended: 'There is an issue with your identity verification. Please <a class="link-4" href="/company/contact-us">contact us</a> to resolve this issue.',
    retry: 'We were unable to verify your identity. Please <a class="link-1" href="/profile/accounts?open=verification">refill</a> the ID verification form to correct any potential errors.',
    retry_sent: 'ID verification form is sent. It may take some time to verify it.',
    document: 'ID document is needed. Please <a class="link-1" href="/profile/accounts?open=verification">provide</a> the ID document for KYC requirements.',
    document_sent: 'ID verification document is under review. This may take up to 48 hours to complete.',
    deactivated: 'There is an issue with your identity verification. Please <a class="link-4" href="/company/contact-us">contact us</a> to resolve this issue.',
  },
  INVESTMENT_GET_CLOSED_BY_MANAGER_MESSAGE(farmName, farmSlug) {
    return [`Your investment in <a class="link-1" href="/${farmSlug}">${farmName}</a> was canceled.`,
      `If this cancellation was in error or if you have questions, you may reach out to us directly
      at our <a class="link-1 small-link" href="/company/contact-us">contact page</a> or call us anytime at
      <strong>(479) 335-5660</strong>`];
  },
  INVESTMENT_GET_CLOSED_NOT_SUCCESSFULLY_MESSAGE(farmName) {
    return [`Unfortunately, the <strong>${farmName}</strong> opportunity did not close successfully.`,
      `This happens in rare circumstances, often due to unforeseen external issues that we discover
     aren’t ideal for our investors. Your escrowed funds will be fully refunded as immediately as
     possible. We’re sorry for the inconvenience, and invite you to explore other opportunities to invest
     <a class="link-1 small-link" href="/explore">here</a>.`];
  },
  INVESTMENT_PROFILE_TO_KYC_BUSINESS_TYPE_MAP: {
    LLC: 'llc',
    Corporation: 'corporation',
    'Limited Partnership': 'partnership',
    'General Partnership': 'partnership',
  },
  INACTIVE_LOGOUT_MESSAGE: [
    'You have been automatically logged out due to inactivity for one or more hours.',
    `This feature is intended to protect the security of your account. If you wish to
    continue your session, please log in`,
  ],
  ELECTRONIC_SIGNATURES_FORM_URL: 'https://github.com/acretrader/general/files/2258865/AcreTrader.Electronic.Records.and.Signatures.Form.pdf',
  GENERAL_RISK_STATEMENT_URL: 'https://acretrader.com/docs/Acretrader-General-Risk-Statement.pdf?origin_team=TA8QG69FZ',
  SERVER_GENERAL_ERROR_MESSAGE: 'Something appears to be wrong. Please try again in a few minutes.',
  SERVER_GENERAL_ERROR_MESSAGE2: 'An error occurred. Please try again or contact us <a class="link-1 small-link" href="/company/contact-us">here</a>.',
  SERVER_AUTH_ERROR_MESSAGE: 'Authentication problem. Please log in again.',
  EMAIL_VERIFICATION_ERROR_MESSAGE: `In order to access this functionality you must verify your email address.
  Check your email for the link we sent you, then click it to confirm your address.
  If you didn't receive an email from us please click
  <a class="link-1" href="/profile/settings">here</a> to resend another verification email.`,
  BOOLEAN_RADIO: [
    {
      text: 'Yes',
      value: true,
    }, {
      text: 'No',
      value: false,
    },
  ],
  STATUS: {
    PENDING: 0,
    DONE: 1,
    ERROR: -1,
  },
  RELATIVE_RISK: [
    {
      text: 'Low',
      color: '#4ECDC4',
    },
    {
      text: 'Moderate',
      color: '#4421AA',
    },
    {
      text: 'High',
      color: '#FF934F',
    },
    {
      text: 'Speculative',
      color: '#D91F11',
    },
  ],
  // table on main page
  // Cols: 1 - fa-check-circle, -1 - hr, 0 - fa-times-circle
  FARMLAND_TABLE: [
    {
      title: 'Attractive Yield',
      cols: [1, -1, 1, 1, 0],
    },
    {
      title: 'Low Volatility',
      cols: [1, 0, 1, 0, 1],
    },
    {
      title: 'Equity Build Up',
      cols: [1, 1, 0, 1, 0],
    },
    {
      title: 'Low Leverage',
      cols: [1, 0, 1, 0, 1],
    },
    {
      title: 'Hard Asset',
      cols: [1, 0, 0, 1, 0],
    },
    {
      title: 'Inflation Hedge',
      cols: [1, 1, 0, 1, 0],
    },
  ],
  PROFILE_SETTINGS_RADIO_GROUP: [
    {
      text: 'I consent to have Schedules K-1 for each of my investments furnished electronically via this portal rather than mailed to my designated address.',
      value: 'schedules_k1_consent',
    },
    {
      text: 'I elect to have Schedules K-1 for each of my investments mailed to my designated address.',
      value: 'schedules_k1_elect',
    },
  ],
  AUTH_PROVIDERS: {
    AUTH0: 'Auth0',
  },
  WALLET_INITIAL_LOAD_TRANSACTION_NUMBER: 25,
  CREATE_ACCOUNT_STEPS: [
    {
      name: 'Investment Account',
      value: 'investment account',
    },
    {
      name: 'Investment Suitability',
      value: 'investment suitability',
    },
  ],
  CREATE_ACCOUNT_STEPS_CONST: {
    ACCOUNT: 'investment account',
    INVESTMENT: 'investment suitability',
  },
  CREATE_ACCOUNT_LEAVE_MESSAGES: {
    PROCESS: 'Please note that your investment will not be reserved until you complete the process. Are you sure you want to leave?',
    STEP: 'Please note that you have unsaved changes on this step. Are you sure you want to leave?',
    CANCEL: 'Are you sure you want to cancel this investment?',
  },
};

// Import global constants from submodule
const context = require.context('../../const', true, /\.json$/);
context.keys().forEach((fileName) => {
  const path = fileName.split('/');
  const constName = path[path.length - 1].split('.').shift();
  if (path.length > 2) {
    const subDir = {};
    subDir[constName] = context(fileName);
    consts[path[1]] = subDir;
  } else {
    consts[constName] = context(fileName);
  }
});

module.exports = consts;
